enum WorkyPasswordCriterionId {
    LOWERCASE = 'LOWERCASE',
    UPPERCASE = 'UPPERCASE',
    NUMBER = 'NUMBER',
    MINIMUM_LENGTH = 'MINIMUM_LENGTH',
    SPECIAL_CHARACTER_OR_SPACE = 'SPECIAL_CHARACTER_OR_SPACE',
    NO_LEADING_OR_TRAILING_SPACE = 'NO_LEADING_OR_TRAILING_SPACE',
}

interface WorkyPasswordCriterionEvaluation {
    readonly id: WorkyPasswordCriterionId;
    readonly label: string;
    readonly isMet: boolean;
}

export type { WorkyPasswordCriterionEvaluation };
export { WorkyPasswordCriterionId };
